'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var ReturnsProvider = require('../providers/ReturnsProvider.js');
var generated = require('../graphql/generated.js');

const useReturns = () => {
  const context = React.useContext(ReturnsProvider.ReturnsContext);
  if (!context) {
    throw new Error('This hook must be used inside a ReturnsProvider');
  }
  const {
    client,
    orderData,
    selectedItems,
    prefill,
    overrideCode,
    submittedReturn,
    setSubmittedReturn,
    setOrderData,
    setSelectedItems,
    returnCart,
    setReturnCart,
    localeCountry,
    localeLanguage,
    moniker,
    selectedPudoOption,
    setSelectedPudoOption,
    initUnauthenticatedClient,
    initAuthenticatedClient,
    submittedReturnsForOrder,
    setSubmittedReturnsForOrder,
    userRole
  } = context;
  return {
    client,
    orderData,
    selectedItems,
    prefill,
    overrideCode,
    submittedReturn,
    setSubmittedReturn,
    setOrderData,
    setSelectedItems,
    returnCart,
    setReturnCart,
    localeCountry,
    localeLanguage,
    moniker,
    selectedPudoOption,
    setSelectedPudoOption,
    initUnauthenticatedClient,
    initAuthenticatedClient,
    submittedReturnsForOrder,
    setSubmittedReturnsForOrder,
    userRole
  };
};

exports.CancelSubmittedReturnDocument = generated.CancelSubmittedReturnDocument;
exports.CommonPudoOptionFieldsFragmentDoc = generated.CommonPudoOptionFieldsFragmentDoc;
exports.CommonReturnCartFieldsFragmentDoc = generated.CommonReturnCartFieldsFragmentDoc;
exports.CreateReturnCartDocument = generated.CreateReturnCartDocument;
exports.CustomerFragmentDoc = generated.CustomerFragmentDoc;
exports.EmailSubmittedReturnDetailsDocument = generated.EmailSubmittedReturnDetailsDocument;
exports.GetLocationsDocument = generated.GetLocationsDocument;
exports.GetOrderInfoAndSubmittedReturnsDocument = generated.GetOrderInfoAndSubmittedReturnsDocument;
exports.GetPudoOptionsDocument = generated.GetPudoOptionsDocument;
exports.GetShippingLabelInfoDocument = generated.GetShippingLabelInfoDocument;
exports.HipaaCreateReturnCartDocument = generated.HipaaCreateReturnCartDocument;
exports.HipaaGetOrderInfoAndSubmittedReturnsDocument = generated.HipaaGetOrderInfoAndSubmittedReturnsDocument;
exports.HipaaPudoOptionFragmentDoc = generated.HipaaPudoOptionFragmentDoc;
exports.HipaaSetPudoOptionDocument = generated.HipaaSetPudoOptionDocument;
exports.HipaaSubmitReturnCartDocument = generated.HipaaSubmitReturnCartDocument;
exports.OrderFragmentDoc = generated.OrderFragmentDoc;
exports.PudoOptionBaseFragmentDoc = generated.PudoOptionBaseFragmentDoc;
exports.PudoOptionFragmentDoc = generated.PudoOptionFragmentDoc;
exports.ReturnFragmentDoc = generated.ReturnFragmentDoc;
exports.SelectedDropoffFragmentDoc = generated.SelectedDropoffFragmentDoc;
exports.SetPudoOptionDocument = generated.SetPudoOptionDocument;
exports.SubmitReturnCartDocument = generated.SubmitReturnCartDocument;
exports.useCancelSubmittedReturnMutation = generated.useCancelSubmittedReturnMutation;
exports.useCreateReturnCartMutation = generated.useCreateReturnCartMutation;
exports.useEmailSubmittedReturnDetailsMutation = generated.useEmailSubmittedReturnDetailsMutation;
exports.useGetLocationsLazyQuery = generated.useGetLocationsLazyQuery;
exports.useGetLocationsQuery = generated.useGetLocationsQuery;
exports.useGetOrderInfoAndSubmittedReturnsLazyQuery = generated.useGetOrderInfoAndSubmittedReturnsLazyQuery;
exports.useGetOrderInfoAndSubmittedReturnsQuery = generated.useGetOrderInfoAndSubmittedReturnsQuery;
exports.useGetPudoOptionsLazyQuery = generated.useGetPudoOptionsLazyQuery;
exports.useGetPudoOptionsQuery = generated.useGetPudoOptionsQuery;
exports.useGetShippingLabelInfoLazyQuery = generated.useGetShippingLabelInfoLazyQuery;
exports.useGetShippingLabelInfoQuery = generated.useGetShippingLabelInfoQuery;
exports.useHipaaCreateReturnCartMutation = generated.useHipaaCreateReturnCartMutation;
exports.useHipaaGetOrderInfoAndSubmittedReturnsLazyQuery = generated.useHipaaGetOrderInfoAndSubmittedReturnsLazyQuery;
exports.useHipaaGetOrderInfoAndSubmittedReturnsQuery = generated.useHipaaGetOrderInfoAndSubmittedReturnsQuery;
exports.useHipaaSetPudoOptionMutation = generated.useHipaaSetPudoOptionMutation;
exports.useHipaaSubmitReturnCartMutation = generated.useHipaaSubmitReturnCartMutation;
exports.useSetPudoOptionMutation = generated.useSetPudoOptionMutation;
exports.useSubmitReturnCartMutation = generated.useSubmitReturnCartMutation;
exports["default"] = useReturns;
